import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../assets/images/Asiamarket.png';
import { hasVerifiedAdminPanelAccess, logout } from '../utils/auth';
import './AppNav.css';

const computeIsAdmin = () => {
  const roleId = localStorage.getItem('roleId');
  const roleKey = (localStorage.getItem('roleNameKey') || '').toLowerCase();
  if (roleId && Number(roleId) === 1) return true;
  return roleKey === 'administrators' || hasVerifiedAdminPanelAccess();
};

const linkClass = ({ isActive }) => `appnav-link${isActive ? ' is-active' : ''}`;

const AppNav = ({ isAdmin }) => {
  const navigate = useNavigate();
  const admin = typeof isAdmin === 'boolean' ? isAdmin : computeIsAdmin();
  const operator = (localStorage.getItem('operator') || localStorage.getItem('username') || '').trim();
  const initial = operator ? operator.charAt(0).toUpperCase() : '?';

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="appnav">
      <div className="appnav-inner">
        <button className="appnav-brand" onClick={() => navigate('/order-list')} aria-label="Home">
          <img src={logo} alt="Asia Market" />
        </button>

        <nav className="appnav-links">
          <NavLink to="/order-list" className={linkClass}>Orders</NavLink>
          <NavLink to="/picking" className={linkClass}>Picking</NavLink>
          <NavLink to="/multi-picking" className={linkClass}>Multi-order</NavLink>
          <NavLink to="/on-hold" className={linkClass}>On Hold</NavLink>
          {admin && (
            <>
              <NavLink to="/admin/operators" className={linkClass}>Operators</NavLink>
              <NavLink to="/admin/sla" className={linkClass}>SLA</NavLink>
              <NavLink to="/admin/overview" className={linkClass}>Overview</NavLink>
            </>
          )}
        </nav>

        <div className="appnav-right">
          <span className="appnav-user">
            <span className="appnav-avatar">{initial}</span>
            <span className="appnav-username">{operator || 'Operator'}</span>
          </span>
          <button className="appnav-logout" onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </header>
  );
};

export default AppNav;
